function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: "15.29",
  height: "14.29",
  viewBox: "0 0 15.29 14.29",
  stroke: "currentcolor",
  fill: "currentcolor",
  strokeWidth: "0",
  width: "1em",
  height: "1em"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M7.64 7.64a3.82 3.82 0 113.83-3.82 3.82 3.82 0 01-3.83 3.82zm0 1.87c3.05 0 5.78.55 7.65 2.93v1.85H0v-1.85C1.87 10.06 4.6 9.5 7.64 9.5z"
})));